// src/components/Footer.jsx
import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { siteConfig, getWhatsAppUrl } from '@/lib/siteConfig';

export default function Footer() {
  const ano = new Date().getFullYear();
  const contato = siteConfig?.contact || siteConfig?.contato || {};

  return (
    <footer className="footer" role="contentinfo">
      <div className="container" id="contato">
        {/* Grid principal */}
        <div className="footer-grid">
          {/* Coluna 1: Marca */}
          <div className="footer-brand">
            <Link
              to="/"
              className="footer-logo"
              aria-label={`${siteConfig?.nome || 'CLEH TECH'} — Início`}
            >
              {siteConfig?.nome || 'CLEH TECH'}
            </Link>
            <p className="footer-desc">
              Suporte e soluções em tecnologia para pessoas e negócios locais.
              Atendemos {contato?.cidadeUF || 'Ferraz de Vasconcelos/SP'}. Sites
              rápidos, SEO e automações.
            </p>
          </div>

          {/* Coluna 2: Navegação útil */}
          <nav aria-label="Links do site" className="footer-nav">
            <h3 className="footer-title">Navegação</h3>
            <ul className="footer-list">
              <li>
                <NavLink className="footer-link" to="/">
                  Início
                </NavLink>
              </li>
              <li>
                <NavLink className="footer-link" to="/servicos">
                  Serviços
                </NavLink>
              </li>
              <li>
                <a className="footer-link" href="#contato">
                  Contato
                </a>
              </li>
            </ul>
          </nav>

          {/* Coluna 3: Contato */}
          <section className="footer-contact" aria-label="Informações de contato">
            <h3 className="footer-title">Contato</h3>
            <address className="footer-address">
              <p>
                <a className="link" href={`mailto:${contato?.email || 'contato@clehtech.com'}`}>
                  {contato?.email || 'contato@clehtech.com'}
                </a>
              </p>
              <p>
                <a
                  className="link"
                  href={getWhatsAppUrl()}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {contato?.telefone || '+55 (11) 99999-9999'}
                </a>
              </p>
            </address>
            <div className="footer-social" aria-label="Redes sociais">
              {/* Exemplo:
              <a className="link" href="https://instagram.com/..." aria-label="Instagram">Instagram</a>
              */}
            </div>
          </section>
        </div>

        {/* Faixa inferior */}
        <div className="footer-bottom">
          <span>
            © {ano} {siteConfig?.nome || 'CLEH TECH'}. Todos os direitos reservados.
          </span>

          <div className="footer-legal" aria-label="Documentos legais">
            <NavLink className="link-muted" to="/politica-privacidade">
              Política de Privacidade
            </NavLink>
            {/* <NavLink className="link-muted" to="/termos">Termos de Uso</NavLink> */}
          </div>

          <a className="to-top link" href="#root" aria-label="Voltar ao topo">
            ↑ Topo
          </a>
        </div>
      </div>
    </footer>
  );
}
